/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import { useOutletContext, Link } from "react-router-dom";
// BASE components
import BASESvgIcon from "../../../../../@BASE/core/BASESvgIcon";
// Material UI
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
// cusom components
import EmptyListing from '../../listing/EmptyListing';

export default function VersionView(props) {
  const { resource, instance } = useOutletContext();
  const versions = instance.archived_versions;

  if (!versions.length > 0) {
    return (
      <div className="relative flex flex-col flex-auto mt-64 px-24 sm:px-48">
        <EmptyListing resource="versions" />
        <Button
          to="new/edit"
          component={Link}
          className="px-16 min-w-128"
          variant="outlined"
          endIcon={
            <BASESvgIcon className="" size={20}>
              heroicons-solid:plus
            </BASESvgIcon>
          }
        >
          Add Version
        </Button>
      </div>
    )
  }

  return (
    <div className="relative flex flex-col flex-auto mt-64 px-24 sm:px-48">
      <Typography className="mt-12 text-2xl font-bold truncate">
        Versions View
      </Typography>
      <Divider className="mt-16 mb-24" />
    </div>
  );
}